const StoreCreditIcon = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 30"
            width={30}
            height={30}
            x="0px"
            y="0px"
            {...props}
        >
            <path d="M19,5H5A2,2,0,0,0,3,7V17a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V7A2,2,0,0,0,19,5Zm1,12a1.00115,1.00115,0,0,1-1,1H5a1.00115,1.00115,0,0,1-1-1V12h8.44336L11,14.5l.866.5,1.732-3h.82459L16.183,15.049l.866-.5L15.57733,12H20Zm-8-7a1,1,0,1,1,1-1A1.00115,1.00115,0,0,1,12,10Zm4,0a1,1,0,1,1,1-1A1.00115,1.00115,0,0,1,16,10Zm4-1H18a2,2,0,0,0-4,0,2,2,0,0,0-4,0H4V7A1.00115,1.00115,0,0,1,5,6H19a1.00115,1.00115,0,0,1,1,1Z" />
            <text
                x={0}
                y={39}
                fill="#000000"
                fontSize="5px"
                fontWeight="bold"
                fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
            />
            <text
                x={0}
                y={44}
                fill="#000000"
                fontSize="5px"
                fontWeight="bold"
                fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
            />
        </svg>
    )
}

export default StoreCreditIcon
